<template>
  <loading-overlay :show="show_overlay" :default="true">
    <div class="card invoiced-card">
      <div class="card-header">
        <div class="heading-small">Sent</div>
        <div>
          <button type="button" class="btn btn-silent" :disabled="downloading || _downloadableInvoices.length === 0" @click="download">
            Download invoices
          </button>
          <button type="button" class="btn btn-silent" :disabled="downloading || _downloadableInvoices.length === 0" @click="downloadExcel">
            Download excel
          </button>
        </div>
      </div>
      <div class="card-body">
        <table>
          <tr>
            <th>Client/Project</th>
            <th>Income</th>
            <th>Invoice</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
          <template v-for="client in invoiced_clients">
            <tr class="cursor-pointer" @click="expandClient(client)">
              <td>
              <span class="expand">
                <i v-if="client.id === expanded_client" class="fas fa-chevron-down"></i>
                <i v-else class="fas fa-chevron-right"></i>
                <span class="table-strong ml-2">{{ client.client_name }}</span>
              </span>
              </td>
              <td class="font-weight-bold">
                <span>{{ client.generated_money > 0 ? client.generated_money : null }} &euro;</span>
                <span v-if="client.credited_amount > 0">(-{{ client.credited_amount }} &euro;)</span>
              </td>
              <td></td>
              <td>
                {{ client.invoices_completed }} / {{ client.total_invoices }}

                <span v-if="client.invoices_sending > 0">
              <i class="fa fa-sync fa-spin text-warning"></i>
            </span>
                <span v-if="client.invoices_sent === client.total_invoices">
              <i class="fa fa-check text-success"></i>
            </span>
                <span v-if="client.invoices_failed_sending > 0">
              <i class="fa fa-times text-danger"></i>
            </span>
              </td>
              <td>
                <button type="button" class="btn btn-invisible">
                  <i class="fas fa-paper-plane"></i>
                </button>
              </td>
            </tr>

            <!--projects-->
            <tr class="project" v-for="project in client.projects" v-if="client.id === expanded_client">
              <td>{{ project.project_name }}</td>
              <td class="table-strong">
                <span v-if="project.generated_money > 0 && project.credited_amount === 0">{{ project.generated_money }} &euro;</span>
                <span v-if="project.credited_amount > 0">-{{ project.credited_amount }} &euro;</span>
              </td>
              <td>
                <a class="chip chip-orange" :href="project.invoice.preview_url" v-if="project.invoice" target="_blank">
                  #{{ project.invoice.full_number }}
                </a>

                <a class="chip chip-red ml-1"
                   :href="project.invoice.credited_invoice.preview_url"
                   v-if="project.invoice && project.invoice.credited_invoice"
                   target="_blank"
                >
                  #{{ project.invoice.credited_invoice.full_number }}
                </a>
              </td>
              <td>
                <div v-if="project.invoice.is_sending">
                  Sending <i class="fa fa-sync fa-spin text-warning"></i>
                </div>
                <div v-if="project.invoice.is_sent">
                  Sent <i class="fa fa-check text-success"></i> <br>
                  <span class="color-gray-500">{{ project.invoice.delivered_at }}</span>
                </div>
                <div v-if="project.invoice.is_failed">
                  Sent <i class="fa fa-times text-danger"></i>
                </div>
              </td>
              <td class="actions">
                <button :disabled="project.invoice.is_sending" class="btn btn-secondary" @click="revoke(project.invoice.id)">Revoke</button>
                <button :disabled="project.invoice.is_sending" class="btn btn-secondary" @click="credit(project.invoice)">Credit</button>
              </td>
            </tr>
            <!--projects-->
          </template>
          <total-tr :fill="2" :clients="invoiced_clients" :hide_predicted="true" :hide_first_td="true"></total-tr>
        </table>
      </div>
    </div>
    <crediting-modal></crediting-modal>
  </loading-overlay>
</template>
<script>
import _ from 'lodash'
import TotalTr from './TotalTr.vue'
import LoadingOverlay from "./LoadingOverlay";
import CreditingModal from "./CreditingModal";

export default {
  props: {
    startDate: {
      required: true,
    },
    endDate: {
      required: true,
    }
  },
  components: {
    TotalTr,
    LoadingOverlay,
    CreditingModal,
  },
  created() {
    this.loadInvoicedClients()

    this.$root.$on('Invoices::reloadIndexTables', () => {
      this.loadInvoicedClients()
    })

    this.$root.$on('Invoices::expandClient', client_id => {
      if (client_id === this.expanded_client) {
        this.expanded_client = null
        return
      }

      this.expanded_client = client_id
    })

    this.$root.$on('Invoices::changeDate', () => {
      this.loadInvoicedClients()
    })

    this.$root.$on('Invoices::downloadSentInvoices', () => {
      this.download()
    })

  },
  data() {
    return {
      invoiced_clients: null,
      invoice_button_disabled: false,
      expanded_client: null,
      downloading: false,
      exporting_xlsx: false,
      show_overlay: false,
    }
  },
  computed: {
    _downloadableInvoices() {
      return _.flatten(_.map(this.invoiced_clients, i => i.downloadable_invoices))
    }
  },
  methods: {
    loadInvoicedClients(show_overlay = true) {
      this.show_overlay = show_overlay
      let data = {
        startDate: this.startDate,
        endDate: this.endDate,
      }
      this.axios.get('/invoices2/sent', {params: data}).then(response => {
        this.invoiced_clients = response.data.data
        this.checkInvoicesSending()
      }).finally(() => {
        this.show_overlay = false
      })
    },
    expandClient(client) {
      this.$root.$emit('Invoices::expandClient', client.id)
    },
    checkInvoicesSending() {
      let app = this
      setTimeout(function () {
        let index = _.findIndex(app.invoiced_clients, c => c.total_invoices > c.invoices_completed)
        if (index > -1) {
          app.loadInvoicedClients(false)
        }
      }, 5000)
    },
    revoke(invoice_id) {
      if (!confirm('Are you sure?')) return false

      this.axios.post('/invoices2/revoke', {invoice_id}).then(response => {
        this.$root.$emit('Invoices::reloadIndexTables')
      }).catch(e => {
        this.$root.$emit('Invoices::reloadIndexTables')
      })
    },
    credit(invoice) {
      this.$root.$emit('Invoices::openCreditingModal', {invoice})
    },
    download() {
      this.downloading = true
      let invoices = this._downloadableInvoices
      this.axios.get('/invoices2/download', {
        responseType: 'blob',
        params: {invoices}
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'invoices.gz');
        document.body.appendChild(link);
        link.click();
      }).finally(() => {
        this.downloading = false
      })
    },
    downloadExcel() {
      this.downloading = true
      let invoices = this._downloadableInvoices
      this.axios.get('/invoices2/download-excel', {
        responseType: 'blob',
        params: {invoices}
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'invoices.xls');
        document.body.appendChild(link);
        link.click();
      }).finally(() => {
        this.downloading = false
      })
    },
  }

}
</script>
<style lang="scss">



// WEBPACK FOOTER //
// src/views/invoices2/InvoicedClients.vue